// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"styles_tableHeadCell__Jc8K-","tableRow":"styles_tableRow__lpSbY","tableBodyCell":"styles_tableBodyCell__Ffi21"};